module.exports = __webpack_public_path__ + "img/IAR12.7187fb49.png";